import React from "react";

import Text from "src/components/text";
import { formatTimespent } from "src/services/reports.service";

import styles from "./userGroupItem.module.scss";
import { UserGroup } from "src/types/users";
import { Analytics } from "src/types/reports";

export interface UserGroupListItemProps {
  item: {
    userGroup: UserGroup;
    analytics: Analytics;
  };
  columnCount: number;
}

export const UserGroupListItem: React.FC<UserGroupListItemProps> = ({
  item,
  columnCount,
}) => {
  const { userGroup, analytics } = item;
  return (
    <div className={styles.tableRow} key={userGroup.id}>
      <div className={styles.tableDataContainer}>
        <div className={styles.imageIcon}>
          {userGroup.icon?.thumbnail ? (
            <img src={userGroup.icon.thumbnail} alt="User Icon" />
          ) : (
            <span className={styles.initials}>
              {(userGroup.name?.charAt(0) || "U").toUpperCase()}
            </span>
          )}
        </div>
        <a
          href={`/settings/user-management/group/${userGroup.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text
                lines={1}
                className={styles.title}
                text={userGroup.name || ""}
              />
            </div>
            <span className={styles.metricsData}>
              <span className={styles.name}>
                Users: <span>{userGroup.usersCount}</span>
              </span>
            </span>
          </div>
        </a>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{analytics.views}</div>
        <div className={styles.tableDataTime}>
        {formatTimespent(analytics.avgTimeSpent || 0)}
        </div>
        <div className={styles.tableDataShares}>{analytics.shares}</div>
      </div>
    </div>
  );
};
